'use strict';

var helper = require('../helper');

module.exports = {
    pushScalaAndKlarnPayModalInteraction (payment, page) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '64',
            'eventname': 'payment_info',
            'payment_method': payment
        };

        helper.log('Pushing ScalaPay modal interaction', true);
        helper.push(pushObject);
    }
};
